/**
 * Provides SafeModeling which uses SafeMoveShapeHandler for shape.move.
 * Replaces the default BPMN Modeling to fix pool drop crashes.
 */
import SafeModeling from './SafeModeling';

const safeModelingModule = {
  modeling: ['type', SafeModeling],
};
export default safeModelingModule;
